import { Box } from "@vinomofo/components";
import styled from "styled-components";
import whiteBrush from "./white-brush.png";

export const Brush = styled(Box)`
  pointer-events: none;
`;

const DividerBrush = () => {
  return (
    <Box
      justifyContent={"center"}
      display="flex"
      alignContent={"center"}
      pt={10}
    >
      <Brush
        as="img"
        src={whiteBrush}
        alt="Divider Bush"
        verticalAlign="middle"
        height="100%"
        width="100%"
        marginBottom={"-4%"}
      />
    </Box>
  );
};

export default DividerBrush;
